import $bridge from '@common/bridge';
import $store from '@store';
import types from '@store/system/types';
import services from '../services';

const appid = 'wx614a03c4abfe18da';
const ua = window.navigator.userAgent.toLowerCase();
let loginPath = '';
// eslint-disable-next-line eqeqeq
if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    // 判断是否为微信环境
    loginPath = [
        '/youcai',
        '/flower',
        // '/ancientOffer/default',
        // '/ancientOffer/kzl',
        // '/ancientOffer/yxs',
        // '/ancientOffer/duomai',
        '/shuiyi/default',
        '/shuiyi/kzl',
        '/discountLogin/default',
        '/discountLogin/114la',
        '/discountLogin/lmayy',
        '/discountLogin/shsp',
        '/discountLogin/ydgy',
        '/discountLogin/dw-wx-hl',
        '/giftBag/default',
        '/giftBag/114la',
        '/giftBag/lmayy',
        '/giftBag/shsp',
        '/giftBag/ydgy',
        '/giftBag/dw-wx-hl',
        // '/summerprize/default',
        // '/summerprize/tuiguang1',
        // '/summerprize/tuiguang2',
        '/midFestival/shsp',
        '/arithmetic/default',
        '/arithmetic/shequn',
        '/arithmetic/tuiguang1',
        '/arithmetic/tuiguang2',
        '/springfes/default',
        '/springfes/shequn',
        '/springfes/yanxishe',
        '/collectCards/default',
        '/votepage',
        '/julydraw',
        '/chinajoyticket/phone',
        '/chinajoyticket/bag',
        '/chinajoyticket/shirt',
        '/verifyUser/s',
        '/verifyUser/ss',
        '/verifyUser/sss',
        '/chinajoyticket/s',
        '/chinajoyticket/ss',
        '/chinajoyticket/sss',
    ];
} else {
    // 微信授权配置
    loginPath = [
        '/youcai',
        '/flower',
        // '/ancientOffer/default',
        // '/ancientOffer/kzl',
        // '/ancientOffer/yxs',
        // '/ancientOffer/duomai',
        '/shuiyi/default',
        '/shuiyi/kzl',
        // '/summerprize/default',
        // '/summerprize/tuiguang1',
        // '/summerprize/tuiguang2',
        '/arithmetic/shequn',
        '/arithmetic/default',
        '/arithmetic/tuiguang1',
        '/arithmetic/tuiguang2',
        '/springfes/default',
        '/springfes/shequn',
        '/springfes/yanxishe',
        '/collectCards/default',
        '/votepage',
        '/chinajoyticket/phone',
        '/chinajoyticket/bag',
        '/chinajoyticket/shirt',
        '/verifyUser/s',
        '/verifyUser/ss',
        '/verifyUser/sss',
        '/chinajoyticket/s',
        '/chinajoyticket/ss',
        '/chinajoyticket/sss',
    ];
}

function loginFn(path) {
    let arr = path.split('/');
    let channel = arr.pop();
    const uri = encodeURIComponent(
        `${location.protocol}//${location.host}${location.pathname}${
            location.search
        }`
    );
    if (!loginPath.length || !loginPath.find((v) => v === path)) {
        return new Promise((resolve) => resolve());
    }
    return new Promise((resolve) => {
        const isApp = $bridge.isApp;
        if (isApp) {
            services
                .getInfo()
                .then((res) => {
                    if (res.returnCode === 0) {
                        $store.dispatch(types.userInfo, {
                            nickName: res.data.nickName || '',
                            portraitUrl: res.data.picUrls
                                ? `http://act.ywbjchina.com/getImage?url=${
                                      JSON.parse(res.data.picUrls).s
                                  }`
                                : '',
                            unionId: res.data.unionId || '',
                        });
                        localStorage.setItem(
                            'userInfo',
                            JSON.stringify(res.data)
                        );
                        resolve(res.data);
                    } else {
                        //if (res.returnCode === -10250003) {
                        $bridge.toLogin();
                        //}
                    }
                })
                .catch(() => {
                    resolve();
                });
        } else {
            const search = window.location.search
                .replace(/\?/, '')
                .split('&')
                .reduce((pre, cur) => {
                    const ary = cur.split('=');
                    pre[ary[0]] = ary[1];
                    return pre;
                }, {});

            // eslint-disable-next-line
            if (localStorage.getItem('authorization')) {
                $store.dispatch(
                    types.authorization,
                    localStorage.getItem('authorization')
                );
                services.getInfo().then((res2) => {
                    if (res2.returnCode != 0) {
                        localStorage.setItem('authorization', '');
                        window.location.replace(
                            `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${uri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
                        );
                        return;
                    }
                    $store.dispatch(types.userInfo, {
                        nickName: res2.data.nickName || '',
                        portraitUrl: res2.data.picUrls
                            ? `http://act.ywbjchina.com/getImage?url=${
                                  JSON.parse(res2.data.picUrls).s
                              }`
                            : '',
                        unionId: res2.data.unionId || '',
                    });
                    localStorage.setItem('version', '2020041701');
                    localStorage.setItem('userInfo', JSON.stringify(res2.data));
                    resolve(res2.data);
                });
            } else if (search.code) {
                services
                    .wechath5login({
                        token: search.code,
                        channel: channel,
                    })
                    .then((res) => {
                        if (res.returnCode === 0) {
                            $store.dispatch(
                                types.authorization,
                                res.data.token || ''
                            );
                            localStorage.setItem(
                                'authorization',
                                res.data.token || ''
                            );
                            localStorage.setItem(
                                'openId',
                                res.data.wechatOpenid
                            );
                            localStorage.setItem('version', '2020041701');
                            localStorage.setItem(
                                'newCreated',
                                res.data.newCreated || 0
                            );
                            services.getInfo().then((res2) => {
                                if (res2.returnCode != 0) {
                                    throw new Error(
                                        res2.returnMessage || '意外错误'
                                    );
                                    return;
                                }
                                $store.dispatch(types.userInfo, {
                                    nickName: res2.data.nickName || '',
                                    portraitUrl: `http://act.ywbjchina.com/getImage?url=${
                                        res2.data.picUrl
                                    }`,
                                    openId: res2.data.wechatOpenid || '',
                                });
                                localStorage.setItem(
                                    'userInfo',
                                    JSON.stringify(res2.data)
                                );

                                window.location.replace(
                                    decodeURIComponent(uri)
                                );
                                resolve(res2.data);
                            });
                        } else {
                            alert('登录失败!' + res.returnMessage || '');
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                        window.location.replace(
                            `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${uri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
                        );
                    });
            } else {
                window.location.replace(
                    `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${uri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
                );
            }
        }
    });
}
/*
function loginFn(path) {
    const uri = encodeURIComponent(`http://act.ywbjchina.com${path}`);
    if (!loginPath.length || !loginPath.find((v) => v === path)) {
        return new Promise((resolve) => resolve());
    }
    return new Promise((resolve) => {
        const isApp = $bridge.isApp;
        if (isApp) {
            services
                .getInfo()
                .then((res) => {
                    if (res.returnCode === 0) {
                        $store.dispatch(types.userInfo, {
                            nickName: res.data.nickName || '',
                            portraitUrl: res.data.picUrls
                                ? `http://act.ywbjchina.com/getImage?url=${
                                      JSON.parse(res.data.picUrls).s
                                  }`
                                : '',
                            unionId: res.data.unionId || '',
                        });
                        resolve(res.data);
                    }
                    resolve(res.data);
                }).catch(() => {
                    window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${uri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`);
                });
        } else {
            const search = window.location.search
                .replace(/\?/, '')
                .split('&')
                .reduce((pre, cur) => {
                    const ary = cur.split('=');
                    pre[ary[0]] = ary[1];
                    return pre;
                }, {});
            // eslint-disable-next-line
            if (!!sessionStorage.getItem('openId')) {
                services
                    .thirdLogin({
                        openId: sessionStorage.getItem('openId'),
                    })
                    .then((res) => {
                        if (res.returnCode === 0) {
                            $store.dispatch(types.userInfo, {
                                nickName: res.data.nickName || '',
                                portraitUrl: `http://act.ywbjchina.com/getImage?url=${res.data.headImgUrl}`,
                                openId: res.data.openId || '',
                                unionId: res.data.unionId || '',
                            });
                            sessionStorage.setItem('openId', res.data.openId);
                            resolve(res.data);
                        }
                    })
                    .catch(() => {
                        window.location.replace(
                            `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${uri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
                        );
                    });
            } else if (search.code) {
                services
                    .wechath5login({
                        token: search.code,
                        channel: 'T-shirtVoting',
                    })
                    .then((res) => {
                        console.log('登陆成功', res);
                        if (res.returnCode === 0) {
                            $store.dispatch(types.userInfo, {
                                nickName: res.data.nickName || '',
                                portraitUrl: `http://act.ywbjchina.com/getImage?url=${res.data.picUrl}`,
                                openId: res.data.wechatOpenid || '',
                            });
                            $store.dispatch(
                                types.authorization,
                                res.data.token || ''
                            );
                            sessionStorage.setItem(
                                'openId',
                                res.data.wechatOpenid
                            );
                            resolve(res.data);
                        }
                        resolve(res.data);
                    })
                    .catch(() => {
                        window.location.replace(
                            `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${uri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
                        );
                    });
                // services.thirdLogin({
                //     code: search.code
                // }).then(res => {
                //     if (res.returnCode === 0) {
                //         $store.dispatch(types.userInfo, {
                //             nickName: res.data.nickName || '',
                //             portraitUrl: `http://act.ywbjchina.com/getImage?url=${res.data.headImgUrl}`,
                //             openId: res.data.openId || ''
                //         });
                //         sessionStorage.setItem('openId', res.data.openId);
                //         resolve(res.data);
                //     }
                // }).catch(() => {
                //     window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${uri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`);
                // });
            } else {
                window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${uri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
            }
        }
    });
}

*/
export default loginFn;
